import { SPC_SECTION } from '../../../../features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';

export const DEFAULT_TRANSITION_DURATION = '1000ms';
export const DEFAULT_TRANSITION_FUNCTION = 'ease-out';
export const TRANSITION_PROPERTY = 'all';
export const HEIGHT_AUTO = 'auto';
export const UNSET = 'unset';
export const OVERFLOW_Y_HIDDEN = 'hidden';
export const DISPLAY_BLOCK = 'block';
export const FADE_OUT_OPACITY = 0.6;
export const FULL_OPACITY = 1;

export const EVENT_TRANSITION_END = 'transitionend';

export const MOBILE = 'MOBILE';
export const TABLET = 'TABLET';
export const DESKTOP = 'DESKTOP';

// Section constants for transitions
export const MY_BAG_TRANSITION_DURATION = 400;
export const CONTACT_TRANSITION_DURATION = 400;
export const SHIPPING_TRANSITION_DURATION = 400;
export const PAYMENT_TRANSITION_DURATION = 400;
export const REWARDS_TRANSITION_DURATION = 400;
export const ORDER_TRANSITION_DURATION = 400;

export const EXPANDED_HEIGHT_CONFIG_KEY = 'expandedHeight';
export const COLLAPSED_HEIGHT_CONFIG_KEY = 'collapsedHeight';

/**
 * Transition config for different sections and viewports
 *
 * [EXPANDED_HEIGHT_CONFIG_KEY]: Final height for transition when expanding
 *
 * [COLLAPSED_HEIGHT_CONFIG_KEY]: Final height for transition when collapsing
 */
export const SPC_SECTION_TRANSITION_CONFIG = {
  [SPC_SECTION.MY_BAG]: {
    id: SPC_SECTION.MY_BAG,
    shouldUseTransition: true,
    transitionDuration: `${MY_BAG_TRANSITION_DURATION}ms`,
    [EXPANDED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 220,
      TABLET: 200,
      DESKTOP: 200,
    },
    [COLLAPSED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 220,
      TABLET: 200,
      DESKTOP: 200,
    },
  },
  [SPC_SECTION.MY_BAG_WITH_EDD]: {
    id: SPC_SECTION.MY_BAG_WITH_EDD,
    shouldUseTransition: true,
    transitionDuration: `${MY_BAG_TRANSITION_DURATION}ms`,
    [EXPANDED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 220,
      TABLET: 250,
      DESKTOP: 344,
    },
    [COLLAPSED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 220,
      TABLET: 232,
      DESKTOP: 262,
    },
  },
  [SPC_SECTION.CONTACT]: {
    id: SPC_SECTION.CONTACT,
    shouldUseTransition: true,
    transitionDuration: `${CONTACT_TRANSITION_DURATION}ms`,
    [EXPANDED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 300,
      TABLET: 300,
      DESKTOP: 300,
    },
    [COLLAPSED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 200,
      TABLET: 300,
      DESKTOP: 300,
    },
  },
  [SPC_SECTION.SHIPPING]: {
    id: SPC_SECTION.SHIPPING,
    shouldUseTransition: true,
    transitionDuration: `${SHIPPING_TRANSITION_DURATION}ms`,
    [EXPANDED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 300,
      TABLET: 300,
      DESKTOP: 300,
    },
    [COLLAPSED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 200,
      TABLET: 300,
      DESKTOP: 300,
    },
  },
  [SPC_SECTION.PAYMENT]: {
    id: SPC_SECTION.PAYMENT,
    shouldUseTransition: true,
    transitionDuration: `${PAYMENT_TRANSITION_DURATION}ms`,
    [EXPANDED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 300,
      TABLET: 300,
      DESKTOP: 300,
    },
    [COLLAPSED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 200,
      TABLET: 300,
      DESKTOP: 300,
    },
  },
  [SPC_SECTION.REWARDS_AND_OFFERS]: {
    id: SPC_SECTION.REWARDS_AND_OFFERS,
    shouldUseTransition: true,
    transitionDuration: `${REWARDS_TRANSITION_DURATION}ms`,
    transitionDurationMs: REWARDS_TRANSITION_DURATION,
    [EXPANDED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 90,
      TABLET: 100,
      DESKTOP: 100,
    },
    [COLLAPSED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 0,
      TABLET: 0,
      DESKTOP: 0,
    },
  },
  [SPC_SECTION.ORDER_SUMMARY]: {
    id: SPC_SECTION.ORDER_SUMMARY,
    shouldUseTransition: true,
    transitionDuration: `${ORDER_TRANSITION_DURATION}ms`,
    transitionDurationMs: ORDER_TRANSITION_DURATION,
    [EXPANDED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 300,
      TABLET: 300,
    },
    [COLLAPSED_HEIGHT_CONFIG_KEY]: {
      MOBILE: 0,
      TABLET: 0,
    },
  },
};

export const RESIZE_OBSERVER_DEBOUNCE_TIME = 3000;
